import { css } from '@emotion/core';
import { colors } from 'styles';

export const placeholder = css`
  border-radius: 21px;
  background: ${colors.lightestGrey};
  padding: 60px 0;
`;
